import { createRouter, createWebHistory } from 'vue-router';
import NProgress from '@/configs/nprogress';
import { beforeEachUtil, saveRouters } from './utils/router-util';
import { reportCurrentUnit } from '@/apis/modules/auth/login/login';
import { useAuthorityStore } from '@/stores/authority';

import baseRouters from './modules/base';
// import indexSsrRouters from './index-ssr';
import systemRouters from './modules/admin/system';
import demoRouters from './modules/admin/demo';
import deployRouters from './modules/admin/configuration';
import orgAuthorityRouters from './modules/admin/org-authority';
import statisticalRouters from './modules/admin/statistical';
import accessRouters from './modules/admin/access';
import userRouters from './modules/admin/user';
import dataMiddleRouters from './modules/admin/data-middle-platform';
import termsRouters from './modules/empty/terms-and-conditions';
import attachmentView from './modules/empty/attachment-view';
import websiteRouters from './modules/admin/website';
import websiteTemplateRouters from './modules/admin/website-template';
import announceRouters from './modules/admin/announce';
import messageRouters from './modules/admin/message';
import homeRouters from './modules/admin/home';
import announceEmptyRouters from './modules/empty/announce';
import workflowRouters from './modules/admin/workflow';
import schoolBasicDataRouters from './modules/admin/school-basic-data';
import messageEmptyRouters from './modules/empty/message';
import flyflowRouters from './modules/mobile/Flyflow';
import mobileMainRouters from './modules/mobile/main';
import mobileLoginRouters from './modules/mobile/login';
import mobileMyRouters from './modules/mobile/my';
import mobileMessageRouters from './modules/mobile/message';
import mobileAnnounceRouters from './modules/mobile/announce';
import mobileRecordRouters from './modules/mobile/record';

const routes = [
  ...baseRouters,
  // ...indexSsrRouters,
  ...systemRouters,
  ...demoRouters,
  ...deployRouters,
  ...orgAuthorityRouters,
  ...statisticalRouters,
  ...termsRouters,
  ...attachmentView,
  ...accessRouters,
  ...userRouters,
  ...dataMiddleRouters,
  ...websiteRouters,
  ...websiteTemplateRouters,
  ...announceRouters,
  ...homeRouters,
  ...announceEmptyRouters,
  ...messageRouters,
  ...workflowRouters,
  ...schoolBasicDataRouters,
  ...messageEmptyRouters,
  ...flyflowRouters,
  ...mobileMainRouters,
  ...mobileLoginRouters,
  ...mobileMyRouters,
  ...mobileMessageRouters,
  ...mobileAnnounceRouters,
  ...mobileRecordRouters,
];
// 存储路由表到store中
saveRouters(routes);
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {
      el: '#app',
      top: 0,
      behavior: 'smooth',
    };
  },
});

// 注册前置路由守卫
router.beforeEach(async (to, from, next) => {
  await beforeEachUtil(to, from, next);
});

// 监听错误
router.onError((handler) => {
  NProgress.done();
  console.log('router.onError', handler);
});

/**
 * @description 路由跳转结束
 * */
router.afterEach((to) => {
  NProgress.done();
  // 移动端记录路由位置，用于设置页面切换动画
  if (to.meta.layout === 'mobile') {
    const routeTo = to;
    routeTo.meta.position = router.options.history.state.position;
  }
  // 上报当前企业微信单位
  // corpId 来源：query 优先，store 兜底；query 有值时同步到 store
  const queryCorpId = to.query?.corpId;
  const storeCorpId = useAuthorityStore().corpId;
  const corpId = queryCorpId || storeCorpId;
  if (corpId) {
    if (queryCorpId && queryCorpId !== storeCorpId) {
      useAuthorityStore().setCorpId(queryCorpId);
    }
    reportCurrentUnit({ corpId }).catch((e) => {
      console.error('上报当前企业微信单位失败', e);
    });
  }
});

export default router;
